/*
 * Built with Common Launchpad 4.0.2
 */

import $ from 'jquery';

class VideoWidgetInline {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        // Title click
        $(document).on('click', '.js-inline-preview', e => {
            e.preventDefault();
            const inlineVideo = $(e.currentTarget);

            // Hide preview Image
            $(inlineVideo).hide();
            // Toggle content visibility
            $(inlineVideo).next('.js-inline-video').show();
        });

        $(document).on('keypress', '.js-inline-preview', e => {
            e.preventDefault();
            if (e.which === 13) {
                const inlineVideo = $(e.currentTarget);

                // Hide preview Image
                $(inlineVideo).hide();
                // Toggle content visibility
                $(inlineVideo).next('.js-inline-video').show();
            }
        });
    }
}

export default VideoWidgetInline;

$(() => {
	const videoWidgetInline = new VideoWidgetInline();
	videoWidgetInline.init();
});